import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../../models/tree-models';

@Component({
  selector: 'app-fs-search',
  templateUrl: './filesystem-search.component.html',
  styleUrls: ['./filesystem-search.component.scss']
})
export class FilesystemSearchComponent {
  @Input() nodes: TreeNode[] = [];
  @Input() activeNodes: TreeNode[] = [];
  @Input() resetSearchNodes: TreeNode[] = [];
  @Input() folderElement: number = 0;
  @Output() folderElementHandler: EventEmitter<number> = new EventEmitter<number>();
  @Output() activeNodesHandler: EventEmitter<TreeNode[]> = new EventEmitter<TreeNode[]>();

  searchTerm: string = '';

  constructor() {}

  reset() {
    this.searchTerm = '';
    this.search();
  }

  search() {
    const risultatiRicerca = [];

    const checkNode = (node: TreeNode) => {
      if (node.name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
        risultatiRicerca.push(node);
      }

      if (node.type === 'folder' && node.children) {
        node.children.forEach(checkNode);
      }
    };

    if (this.searchTerm) {
      this.nodes.forEach(checkNode);
    }

    this.activeNodes = risultatiRicerca.length > 0 ? risultatiRicerca : this.resetSearchNodes;
    this.folderElement = this.activeNodes.length;
    this.folderElementHandler.emit(this.folderElement);
    this.activeNodesHandler.emit(this.activeNodes);
  }
}
